const PREFIX = 'track';

// Initialize dataLayer
window.dataLayer = window.dataLayer || [];

// Tracks click events
const handleClick = (event) => {
  const element = event.target.closest('[data-track-click]');
  if (!element) return;

  const trackClickEvent = element.dataset.trackClick;

  if (trackClickEvent) {
    window.dataLayer.push({
      event: `${PREFIX}_${trackClickEvent}`,
    });
  }
};

// Tracks focus events
const handleFocus = (event) => {
  const element = event.target.closest('[data-track-focus]');
  if (!element) return;

  const trackFocusEvent = element.dataset.trackFocus;

  if (trackFocusEvent) {
    window.dataLayer.push({
      event: `${PREFIX}_${trackFocusEvent}`,
    });
  }
};

// Initialize auto tracking
const init = () => {
  // eslint-disable-next-line no-undef
  if (Shopify.designMode) return; // Don't track in editor mode

  document.addEventListener('DOMContentLoaded', () => {
    // Delegated event listener
    document.body.addEventListener('click', handleClick);
    document.body.addEventListener('focus', handleFocus, true);
  });
};

// Tracks custom events
const track = (event, data = {}) => {
  window.dataLayer.push({
    event: `${PREFIX}_${event}`,
    ...data,
  });
};

export { track, init };
